import { Badge as MuiBadge, BadgeProps as MuiBadgeProps } from '@mui/material';
import { forwardRef } from 'react';

type Props = Pick<
  MuiBadgeProps,
  | 'badgeContent'
  | 'children'
  | 'invisible'
  | 'max'
  | 'overlap'
  | 'variant'
  | 'color'
  | 'anchorOrigin'
  | 'sx'
  | 'className'
> & {
  testId?: string;
  badgeTestId?: string;
};

const Badge = forwardRef<HTMLSpanElement, Props>(
  (
    {
      badgeContent,
      children,
      invisible,
      max,
      overlap,
      variant,
      color = 'accent',
      anchorOrigin,
      sx,
      className,
      testId,
      badgeTestId,
    },
    ref,
  ) => (
    <MuiBadge
      badgeContent={badgeContent}
      invisible={invisible}
      max={max}
      overlap={overlap}
      variant={variant}
      color={color}
      anchorOrigin={anchorOrigin}
      sx={sx}
      className={className}
      test-id={testId}
      slotProps={
        badgeTestId
          ? ({ badge: { 'test-id': badgeTestId } } as MuiBadgeProps['slotProps'])
          : undefined
      }
      ref={ref}
    >
      {children}
    </MuiBadge>
  ),
);

Badge.displayName = 'Badge';
export type { Props as BadgeProps };
export default Badge;
